import * as Api from '../utils/API';
import {
    ENTREGACERTA_DETALHES_NF,
    ENTREGACERTA_DETALHES_NF_LOADING,
    ENTREGACERTA_SCREEN,
    ENTREGACERTA_SAVE_LOADING,
    ENTREGACERTA_RESTRICAO_LOADING,
    ENTREGACERTA_RESTRICAO
} from '../actions/ActionsTypes';


export const detalhesNFAction = (item) => (dispatch) =>
    new Promise(function (resolve, reject) {

        dispatch({ type: ENTREGACERTA_DETALHES_NF_LOADING, payload: true });
        dispatch({ type: ENTREGACERTA_SAVE_LOADING, payload: false });

        if (item.origem === 'W' || item.origem === 'E' || item.origem === 'V') {
            Api.postDetalhesNF(item).then(response => {

                // eslint-disable-next-line
                if (response.length == 0) {
                    dispatch({ type: ENTREGACERTA_SCREEN, payload: 1 });
                }
                dispatch({ type: ENTREGACERTA_DETALHES_NF, payload: response });
                dispatch({ type: ENTREGACERTA_DETALHES_NF_LOADING, payload: false });


                resolve([])


            }).catch(error => {
                reject(error);
            })

        } else {
            dispatch({ type: ENTREGACERTA_SCREEN, payload: 1 });
            resolve([])
        }

    });



export const saveFormAction = (item) => (dispatch) =>
    new Promise(function (resolve, reject) {

        dispatch({ type: ENTREGACERTA_DETALHES_NF_LOADING, payload: true });
        dispatch({ type: ENTREGACERTA_SAVE_LOADING, payload: true });
        Api.postSaveForm(item).then(response => {
            dispatch({ type: ENTREGACERTA_SAVE_LOADING, payload: false });
            dispatch({ type: ENTREGACERTA_DETALHES_NF_LOADING, payload: false });
            resolve(response)
        }).catch(error => {
            dispatch({ type: ENTREGACERTA_SAVE_LOADING, payload: false });
            dispatch({ type: ENTREGACERTA_DETALHES_NF_LOADING, payload: false });
            reject(error);
        })

    });

export const saveRestricaoAction = (item) => (dispatch) =>
    new Promise(function (resolve, reject) {

        dispatch({ type: ENTREGACERTA_RESTRICAO_LOADING, payload: true });
        Api.postSaveEvento(item).then(response => {
            dispatch({ type: ENTREGACERTA_RESTRICAO, payload: false });
            dispatch({ type: ENTREGACERTA_RESTRICAO_LOADING, payload: false });
            resolve(response)
        }).catch(error => {
            dispatch({ type: ENTREGACERTA_RESTRICAO, payload: false });
            dispatch({ type: ENTREGACERTA_RESTRICAO_LOADING, payload: false });
            reject(error);
        })

    });



